import { randomUUID } from "#/shared/utils/string";
import { Model } from "#/shared/models/model";
import { Status } from "./status";

export class Candidate extends Model {
  constructor(attributes = {}) {
    super({ ...attributes, uuid: randomUUID(), createdAt: Date.now() });
    this.status = undefined;
  }

  set status(value) {
    this._status = new Status(value);
  }

  get status() {
    return this._status;
  }
}
